import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { Branch_DeleteFolderButton_32A5F3E1, Branch_EditSupplierButton_2306A009, Branch_SupplierFolderForm_Z3DFDA5BB } from "../Components/TreeAdmin.js";
import { defaultArg, some, map, value as value_120, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableContainer, TableBody, Link, TableHead, TableRow, Checkbox, TableCell, Table, Collapse, Icon, IconButton, Tooltip } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { ViewMode, Message, dispatchCtx, documentsCtx } from "../Documents/DocumentContext.js";
import { hiddenColumn, sourceColumn, syncColumn, dateColumn, Table_FilenameCell_Z6EA07FE8, docTableIconHeader, docTableTextHeader, MachineCategory, filterDocs, docsLoadingIndicators, moveDocHere, treeHasDocuments, TreeState } from "../Documents/DocumentHelpers.js";
import { SnackError, wrapTooltip, SnackAlert, SnackAlertLevel } from "../ViewHelpers.js";
import { singleton as singleton_2, append as append_1, contains, tryFind, partition, map as map_1, pick, choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Tree_isNode, Tree$2_$reflection, Tree_tryNode, Tree_tryLeaf } from "../Shared/Tree.js";
import { toArray, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Upload_EditButton_13687765, UploadTarget, UploadModule_UploadForm } from "../Components/Documents/Upload.js";
import { Button, Form } from "../Components/Documents/Delete.js";
import { Machine_$reflection, DocumentCategory_$reflection, Document$_$reflection, Document$ } from "../Shared/ApiDataTypes.js";
import { stringHash, uncurry2, equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { getFiles, testDragLeave } from "../Utils.js";
import Folder from "@mui/icons-material/Folder";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloudOff from "@mui/icons-material/CloudOff";
import { singleton as singleton_1, cons, empty as empty_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Documents_DocumentSource_FromId_Z524259A4, Localization_Language } from "../Shared/Shared.js";
import Publish from "@mui/icons-material/Publish";
import { createDisposable, useEffectDisposableOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { TreeNode } from "../Components/Documents/CustomerAttachments.js";
import { getDocumentsForCategory } from "../Documents/Trees.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { API_Document_Download, generateQueryString } from "../Shared/Urls.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import Clear from "@mui/icons-material/Clear";
import { toDateStr } from "../Locale.js";
import { parse as parse_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import Visibility from "@mui/icons-material/Visibility";
import Download from "@mui/icons-material/Download";
import { Documents_VisibilityPopup_Z6D335E41 } from "../Components/Documents/VisibilityPopup.js";
import { Documents_ContainerWithFilter_Z2776732D } from "../Components/Documents/DocumentViewer.js";
import { TopLevel_Table_763CA090 } from "../Components/Documents/TopLevel.js";

function AddMachineFolderButton(addMachineFolderButtonInputProps) {
    let props_1;
    const onClose = addMachineFolderButtonInputProps.onClose;
    const parent = addMachineFolderButtonInputProps.parent;
    const machineId = addMachineFolderButtonInputProps.machineId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setCreating = patternInput[1];
    const xs = [createElement(Branch_SupplierFolderForm_Z3DFDA5BB, {
        key: "supplier-add-form",
        $key: "supplier-add-form",
        isOpen: patternInput[0],
        machineId: machineId,
        parent: parent,
        onClose: (newCategoryOpt) => {
            setCreating(false);
            onClose(newCategoryOpt);
        },
        version: unwrap(parent.Version),
    }), MuiHelpers_createElement(Tooltip, [["title", ctx.Locale.t("Document.AddSubFolder")], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        setCreating(true);
    }], ["size", "small"], ["variant", "text"], ["color", "primary"], ["children", (props_1 = {}, react.createElement(Add, props_1))]])]])];
    return react.createElement(react.Fragment, {}, ...xs);
}

/**
 * Draws a single tree entry in the document tree
 */
export function DrawTree(drawTreeInputProps) {
    const category = drawTreeInputProps.category;
    const children = drawTreeInputProps.children;
    const machineId = drawTreeInputProps.machineId;
    const customerId = drawTreeInputProps.customerId;
    const layer = drawTreeInputProps.layer;
    const key = drawTreeInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    let patternInput;
    const initial = new TreeState(false, undefined, undefined, undefined, false);
    patternInput = reactApi.useState(initial);
    const state = patternInput[0];
    const setState = patternInput[1];
    const inside = reactApi.useRef(false);
    const mainElemRef = reactApi.useRef(undefined);
    let patternInput_1;
    const initial_1 = {
        level: new SnackAlertLevel(0, []),
    };
    patternInput_1 = reactApi.useState(initial_1);
    const snackMsg = patternInput_1[0];
    const setSnackMsg = patternInput_1[1];
    let selected;
    const matchValue = model.ViewMode;
    selected = ((matchValue.tag === 0) && ((matchValue.fields[1] === category.Id) && (matchValue.fields[0] === machineId)));
    const hasDocuments = treeHasDocuments(children);
    const patternInput_2 = [choose(Tree_tryLeaf, children), choose(Tree_tryNode, children)];
    let patternInput_3;
    const matchValue_1 = ctx.Session;
    if (matchValue_1 != null) {
        const s = matchValue_1;
        patternInput_3 = [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin];
    }
    else {
        patternInput_3 = [false, false];
    }
    const isPtg = patternInput_3[0];
    const isAdmin = patternInput_3[1];
    const xs_5 = toList(delay(() => {
        let $keyZ3379FC62;
        return append(singleton(($keyZ3379FC62 = (`${key}-snack-error`), createElement(SnackAlert, {
            key: $keyZ3379FC62,
            $key: $keyZ3379FC62,
            level: snackMsg.level,
            msg: unwrap(snackMsg.msg),
            dismiss: () => {
                setSnackMsg({
                    level: snackMsg.level,
                });
            },
        }))), delay(() => {
            let matchValue_4, form;
            return append((matchValue_4 = state.UploadForm, (matchValue_4 != null) ? ((form = matchValue_4, singleton(createElement(UploadModule_UploadForm, {
                target: new UploadTarget(0, [machineId]),
                customerId: customerId,
                tree: category,
                customerAttachment: false,
                files: form,
                onClose: (newDocs) => {
                    dispatch(new Message(1, [machineId, category.Id, newDocs]));
                    setState(new TreeState(state.IsOpen, state.HideForm, undefined, state.DeleteForm, state.DragHovering));
                },
            })))) : (empty())), delay(() => {
                let matchValue_5, document$_2;
                return append((matchValue_5 = state.DeleteForm, (matchValue_5 != null) ? singleton((document$_2 = matchValue_5, createElement(Form, {
                    onClose: (deletedDocOpt) => {
                        if (deletedDocOpt != null) {
                            const doc = deletedDocOpt;
                            dispatch(doc.IsDeleted ? (new Message(6, [machineId, doc.Guid])) : (new Message(17, [machineId, category.Id, new Document$(doc.Guid, doc.Number, doc.CustomerId, doc.Title, doc.CategoryTreeId, doc.TypeId, doc.Machine, doc.SourceId, doc.Date, doc.Uploader, doc.IsHidden, true, doc.Version, doc.Uploaded, doc.ManuallyMoved, doc.ContentId, doc.Filename, doc.ContentSizeBytes, doc.Versions)])));
                        }
                        setState(new TreeState(state.IsOpen, state.HideForm, state.UploadForm, undefined, state.DragHovering));
                    },
                    document: document$_2,
                }))) : (empty())), delay(() => {
                    let elems_5, elements_1;
                    return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => ((!model.Editing && !hasDocuments) ? singleton(["display", "none"]) : empty()))))))))], (elems_5 = [createElement("div", createObj(toList(delay(() => append(singleton(["ref", mainElemRef]), delay(() => append(model.Editing ? append(singleton(["onDragOver", (ev) => {
                        ev.preventDefault();
                    }]), delay(() => append(singleton(["onDragEnter", (ev_1) => {
                        ev_1.preventDefault();
                        inside.current = true;
                        setState(new TreeState(state.IsOpen, state.HideForm, state.UploadForm, state.DeleteForm, true));
                        if (!state.IsOpen) {
                            const pr = new Promise(resolve => setTimeout(resolve, 250));
                            pr.then(() => {
                                if (inside.current) {
                                    setState(new TreeState(true, state.HideForm, state.UploadForm, state.DeleteForm, true));
                                }
                            });
                        }
                    }]), delay(() => append(singleton(["onDragLeave", (ev_2) => {
                        ev_2.preventDefault();
                        if (mainElemRef.current != null) {
                            if (testDragLeave(value_120(mainElemRef.current), ev_2)) {
                                inside.current = false;
                                setState(new TreeState(state.IsOpen, state.HideForm, state.UploadForm, state.DeleteForm, false));
                            }
                        }
                    }]), delay(() => singleton(["onDrop", (ev_3) => {
                        ev_3.preventDefault();
                        inside.current = false;
                        const matchValue_3 = model.DragTarget;
                        if (matchValue_3 != null) {
                            const dt = matchValue_3;
                            const document$_1 = dt.DragTarget.Document;
                            if (equals(map((m) => m.Id, document$_1.Machine), machineId) && equals(dt.DragTarget.Document.CategoryTreeId, category.Id)) {
                                console.warn(some("Moved document to current category"), category.NameEN);
                            }
                            else {
                                moveDocHere(dt, category.Id, machineId, (res) => {
                                    if (res.tag === 0) {
                                        const updatedDocument = new Document$(document$_1.Guid, document$_1.Number, document$_1.CustomerId, document$_1.Title, category.Id, document$_1.TypeId, pick((machine_1) => {
                                            if (machine_1.Machine.Id === machineId) {
                                                return machine_1.Machine;
                                            }
                                            else {
                                                return undefined;
                                            }
                                        }, model.MachineCategories), document$_1.SourceId, document$_1.Date, document$_1.Uploader, document$_1.IsHidden ? document$_1.IsHidden : category.PtgOnly, document$_1.IsDeleted, document$_1.Version, document$_1.Uploaded, defaultArg(res.fields[0].ManuallyMoved, false), document$_1.ContentId, document$_1.Filename, document$_1.ContentSizeBytes, document$_1.Versions);
                                        if (document$_1.IsHidden && !category.PtgOnly) {
                                            dispatch(new Message(3, [updatedDocument]));
                                        }
                                        dispatch(dt.DragTarget.FromTopLevel ? ((dt.OnMoved(), new Message(1, [machineId, category.Id, [updatedDocument]]))) : (new Message(4, [machineId, updatedDocument.CategoryTreeId, updatedDocument])));
                                        setState(new TreeState(true, state.HideForm, state.UploadForm, state.DeleteForm, false));
                                    }
                                    else {
                                        setSnackMsg({
                                            level: new SnackAlertLevel(0, []),
                                            msg: "Noe gikk galt. Kunne ikke flytte dokument. Vennligst prøv igjen senere.",
                                        });
                                    }
                                });
                            }
                        }
                        else if (!(category.AllowUpload && (isAdmin ? true : isPtg))) {
                            console.warn(some("You are not allowed to upload files here."));
                            setSnackMsg({
                                level: new SnackAlertLevel(0, []),
                                msg: "Du kan ikke laste opp filer til denne mappen.",
                            });
                        }
                        else {
                            const files = getFiles(ev_3.dataTransfer.files);
                            if (files.length === 0) {
                                console.warn(some("onDrop without DragTarget or files"));
                            }
                            else {
                                setState(new TreeState(true, state.HideForm, files, state.DeleteForm, false));
                            }
                        }
                        dispatch(new Message(11, [undefined]));
                    }]))))))) : empty(), delay(() => append(singleton(["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["borderRadius", 4 + "px"]), delay(() => append(singleton(["padding", 5]), delay(() => append(singleton(["paddingLeft", 5 + (layer * 40)]), delay(() => (state.DragHovering ? (category.AllowUpload ? singleton(["backgroundColor", "#B0E0E6"]) : singleton(["backgroundColor", "#DB7093"])) : (selected ? singleton(["backgroundColor", "rgba(98, 181, 229, 0.2)"]) : empty())))))))))))))))]), delay(() => {
                        let elems_3;
                        return singleton((elems_3 = toList(delay(() => {
                            let elems_1, elems;
                            return append(singleton(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 10 + "px",
                                flexGrow: 1,
                                fontSize: 0.8 + "rem",
                                cursor: "pointer",
                            }], ["onClick", (_arg_1) => {
                                setState(new TreeState(!state.IsOpen, state.HideForm, state.UploadForm, state.DeleteForm, state.DragHovering));
                                console.debug("[DocumentTree] Clicked folder", category);
                                dispatch(new Message(9, [new ViewMode(0, [machineId, category.Id])]));
                            }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 5 + "px",
                            }], (elems = toList(delay(() => {
                                let props_1;
                                return append(singleton(MuiHelpers_createElement(Icon, [["style", createObj(toList(delay(() => append(singleton(["color", "hsl(207.3, 30%, 28%)"]), delay(() => (!category.PtgOnly ? singleton(["marginRight", 5]) : empty()))))))], ["children", (props_1 = {}, react.createElement(Folder, props_1))]])), delay(() => {
                                    let child, props_4;
                                    return append(category.PtgOnly ? singleton((child = ((props_4 = {
                                        style: {
                                            color: "hsl(207.3, 30%, 28%)",
                                        },
                                    }, react.createElement(VisibilityOff, props_4))), wrapTooltip(ctx.Locale.t("DocumentTree.Admin.VisibilityPtgOnly"), child))) : empty(), delay(() => {
                                        let props_6;
                                        return (model.Editing && !category.AllowUpload) ? singleton((props_6 = {
                                            fontSize: "small",
                                        }, react.createElement(CloudOff, props_6))) : empty();
                                    }));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", {
                                className: join(" ", ["text-overflow"]),
                                children: equals(ctx.Language, new Localization_Language(0, [])) ? category.NameNO : category.NameEN,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(((isAdmin && model.Editing) && category.AllowMachineSubCategories) ? singleton(createElement(AddMachineFolderButton, {
                                machineId: machineId,
                                parent: category,
                                onClose: (newFolderOpt) => {
                                    if (newFolderOpt != null) {
                                        dispatch(new Message(0, [machineId, category.Id, value_120(newFolderOpt)]));
                                    }
                                },
                            })) : empty(), delay(() => append((model.Editing && (category.MachineId != null)) ? append(singleton(createElement(Branch_EditSupplierButton_2306A009, {
                                folder: category,
                                onFormClose: (updatedOpt) => {
                                    if (updatedOpt != null) {
                                        dispatch(new Message(16, [machineId, value_120(updatedOpt)]));
                                    }
                                },
                            })), delay(() => singleton(createElement(Branch_DeleteFolderButton_32A5F3E1, {
                                folder: category,
                                onDelete: () => {
                                    dispatch(new Message(5, [machineId, category.Id]));
                                },
                            })))) : empty(), delay(() => {
                                let elements, props_11;
                                return (isAdmin ? true : isPtg) ? singleton(MuiHelpers_createElement(IconButton, [["onClick", (ev_4) => {
                                    ev_4.stopPropagation();
                                    setState(new TreeState(state.IsOpen, state.HideForm, [], state.DeleteForm, state.DragHovering));
                                }], ["size", "small"], (elements = [(props_11 = {
                                    fontSize: "small",
                                }, react.createElement(Publish, props_11))], ["children", reactApi.Children.toArray(Array.from(elements))])])) : empty();
                            }))))));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_3))]));
                    })))))))))), MuiHelpers_createElement(Collapse, [["mountOnEnter", false], ["unmountOnExit", true], ["in", state.IsOpen], (elements_1 = [map_1((tupledArg) => {
                        const category_1 = tupledArg[0];
                        const $key70163422 = `tree-${category_1.Id}`;
                        return createElement(DrawTree, {
                            key: $key70163422,
                            $key: $key70163422,
                            layer: layer + 1,
                            customerId: customerId,
                            machineId: machineId,
                            children: tupledArg[1],
                            category: category_1,
                        });
                    }, patternInput_2[1])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_5);
}

/**
 * Component for drawing a machine level document tree for a given machine. Will load general tree-structure with document-relations and visiblity based on logged in user
 */
export function DocumentTree(documentTreeInputProps) {
    const machineId = documentTreeInputProps.machineId;
    const customerId = documentTreeInputProps.customerId;
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState([]);
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    useEffectDisposableOnce(() => {
        let properties_2;
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/machine-document-tree/build/${machineId}`, properties_3).then((_arg_1) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 1) {
                setErrMsg("Kunne ikke laste dokumenter");
            }
            else {
                const trees_1 = res.fields[0];
                console.debug("Got tree", trees_1);
                patternInput_1[1](trees_1);
            }
            patternInput[1](false);
        });
        return createDisposable(() => {
            console.debug("Disposing Tree");
        });
    });
    const xs_1 = toList(delay(() => append(singleton(createElement(SnackError, {
        errMsg: unwrap(patternInput_2[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    })), delay(() => (patternInput[0] ? singleton(docsLoadingIndicators()) : append(singleton(map_1((_arg_4) => {
        if (_arg_4.tag === 1) {
            const category = _arg_4.fields[0];
            const $key12D55A89 = `tree-${category.Id}`;
            return createElement(DrawTree, {
                key: $key12D55A89,
                $key: $key12D55A89,
                layer: 0,
                customerId: customerId,
                machineId: machineId,
                children: _arg_4.fields[1],
                category: category,
            });
        }
        else {
            console.debug("Top level tree should not contain leafs");
            return defaultOf();
        }
    }, patternInput_1[0])), delay(() => {
        let elems;
        return singleton(createElement("div", createObj(singleton_1((elems = [createElement(TreeNode, {
            key: "tree-customer-documents",
            $key: "tree-customer-documents",
            customerId: customerId,
            machineId: machineId,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])))));
    })))))));
    return react.createElement(react.Fragment, {}, ...xs_1);
}

/**
 * Wrapper for controlling the filtering and document context
 */
export function DocumentTreeWithFilter(documentTreeWithFilterInputProps) {
    let matchValue, s, matchValue_1, elements_9, children_1, children, children_6, elems_15, elems_13, elems_11, elems_14;
    const machineId = documentTreeWithFilterInputProps.machineId;
    const customerId = documentTreeWithFilterInputProps.customerId;
    const groupId = documentTreeWithFilterInputProps.groupId;
    const key = documentTreeWithFilterInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const setSelectedDocs = patternInput_1[1];
    const selectedDocs = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    const isAdmin = ((matchValue = ctx.Session, (matchValue != null) ? ((s = matchValue, [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin])) : [false, false]))[1];
    const filteredDocs = filterDocs(ctx.DateFnsLocale, undefined, model.Filter, (matchValue_1 = model.ViewMode, (matchValue_1.tag === 2) ? model.CustomerDocs : ((matchValue_1.tag === 1) ? model.EvaticDocuments : ((matchValue_1.tag === 3) ? [] : getDocumentsForCategory(model.MachineCategories, matchValue_1.fields[0], matchValue_1.fields[1])))));
    const patternInput_5 = defaultArg(map((machineDocuments) => {
        const patternInput_4 = partition(Tree_isNode, machineDocuments.Trees);
        return [choose(Tree_tryNode, patternInput_4[0]), choose(Tree_tryLeaf, patternInput_4[1])];
    }, tryFind((category) => (category.Machine.Id === machineId), model.MachineCategories)), [[], []]);
    useEffectWithDeps(() => {
        console.debug("[MachineDocumentTree] Selected category/folder changed", model.ViewMode);
        return createDisposable(() => {
            console.debug("[MachineDocumentTree] Disposing selected category/folder", model.ViewMode);
            setSelectedDocs([]);
        });
    }, [model.ViewMode]);
    useEffectWithDeps(() => {
        let properties_2;
        setLoading(true);
        let pr_5;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(Machine_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`/api/machines/${machineId}`, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Machine_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_5 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_5.then((res) => {
            let properties_6;
            if (res.tag === 0) {
                const requestPath = (`/api/machine-document-tree/build/${machineId}`) + generateQueryString([["deleted", toString_1(model.Filter.ShowDeleted)]]);
                let pr_4;
                let pr_3;
                const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), undefined, undefined);
                const data_5 = undefined;
                const caseStrategy_10 = undefined;
                const extra_10 = extraCoders;
                try {
                    const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(requestPath, properties_3_1).then((_arg_2) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_2, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tree$2_$reflection(Document$_$reflection(), DocumentCategory_$reflection())), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_3) => {
                            let matchValue_3;
                            return Promise.resolve((matchValue_3 = fromString(uncurry2(decoder_1_2), _arg_3), (matchValue_3.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_3.fields[0]])])) : (new FSharpResult$2(0, [matchValue_3.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    pr_3 = (pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
                }
                catch (exn_1) {
                    pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
                pr_4 = (pr_3.then((result_3) => Result_MapError(testRedirect, result_3)));
                pr_4.then((res_1) => {
                    if (res_1.tag === 1) {
                        setErrMsg("Kunne ikke laste dokumenter");
                    }
                    else {
                        dispatch(new Message(15, [[new MachineCategory(res.fields[0], res_1.fields[0])]]));
                    }
                    setLoading(false);
                });
            }
            else {
                console.error(some("Could not fetch machine"), machineId, "err:", res.fields[0]);
                setErrMsg("Kunne ikke laste maskin");
                setLoading(false);
            }
        });
        return createDisposable(() => {
            console.debug("Disposing Tree");
        });
    }, [customerId, machineId, model.Filter.ShowDeleted]);
    const documentTable = MuiHelpers_createElement(Table, [["size", "small"], (elements_9 = [(children_1 = singleton_1((children = toList(delay(() => {
        let elements;
        return append(singleton(MuiHelpers_createElement(TableCell, [["padding", "checkbox"], (elements = [MuiHelpers_createElement(Checkbox, [["disabled", filteredDocs.length === 0], ["onChange", (_arg_4) => {
            if (!(filteredDocs.length === 0) && (selectedDocs.length === filteredDocs.length)) {
                setSelectedDocs([]);
            }
            else {
                setSelectedDocs(map_1((_arg_5) => _arg_5.Guid, filteredDocs));
            }
        }], ["checked", !(filteredDocs.length === 0) && (selectedDocs.length === filteredDocs.length)]])], ["children", reactApi.Children.toArray(Array.from(elements))])])), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Document"))), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["style", {
            fontSize: 0.8 + "rem",
            minWidth: 10 + "ch",
        }], ["variant", "head"], ["children", ctx.Locale.t("History.Date")]])), delay(() => append(singleton(docTableIconHeader(ctx.Locale.t("Document.Sync"))), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Source"))), delay(() => append(isAdmin ? singleton(docTableIconHeader(ctx.Locale.t("Visibility"))) : empty(), delay(() => singleton(MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", "Redigere"]]))))))))))))));
    })), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_6 = map_1((document$_1) => {
        const source = Documents_DocumentSource_FromId_Z524259A4(document$_1.SourceId);
        const downloadUrl = API_Document_Download(parse(document$_1.Guid));
        const isSelected = contains(document$_1.Guid, selectedDocs, {
            Equals: (x_2, y) => (x_2 === y),
            GetHashCode: stringHash,
        });
        return MuiHelpers_createElement(TableRow, toList(delay(() => append(singleton(["key", document$_1.Guid]), delay(() => append(model.Editing ? append(singleton(["draggable", true]), delay(() => append(singleton(["onDragStart", (e) => {
            console.debug("On drag start", e);
        }]), delay(() => singleton(["onDragEnd", (e_1) => {
            console.debug("On drag end", e_1);
        }]))))) : empty(), delay(() => append(singleton(["style", createObj(toList(delay(() => (document$_1.IsDeleted ? singleton(["backgroundColor", "#c1c1c1"]) : empty()))))]), delay(() => append(singleton(["hover", true]), delay(() => {
            let elements_7;
            return singleton((elements_7 = toList(delay(() => {
                let elements_3;
                return append(singleton(MuiHelpers_createElement(TableCell, [["padding", "checkbox"], (elements_3 = [MuiHelpers_createElement(Checkbox, [["onChange", (_arg_6) => {
                    setSelectedDocs(isSelected ? selectedDocs.filter((id) => (id !== document$_1.Guid)) : append_1(selectedDocs, singleton_2(document$_1.Guid)));
                }], ["checked", isSelected]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => append(singleton(createElement(Table_FilenameCell_Z6EA07FE8, {
                    groupId: groupId,
                    customerId: customerId,
                    document: document$_1,
                    machineId: machineId,
                    startAdornments: toArray(delay(() => {
                        let props_7;
                        return document$_1.IsDeleted ? singleton((props_7 = {
                            style: {
                                fontSize: 1.2 + "em",
                            },
                            color: "error",
                        }, react.createElement(Clear, props_7))) : empty();
                    })),
                })), delay(() => append(singleton(dateColumn(toList(delay(() => ((document$_1.Date != null) ? singleton(createElement("span", {
                    children: [toDateStr(ctx.DateFnsLocale, parse_1(value_120(document$_1.Date)))],
                })) : empty()))))), delay(() => append(singleton(syncColumn(ctx.Locale, document$_1)), delay(() => append(singleton(sourceColumn([createElement("span", {
                    children: [toString_1(source)],
                })])), delay(() => append(isAdmin ? singleton(hiddenColumn(toList(delay(() => {
                    let props_11, props_13;
                    return document$_1.IsHidden ? singleton((props_11 = {
                        style: {
                            color: "#FF8C00",
                        },
                    }, react.createElement(VisibilityOff, props_11))) : singleton((props_13 = {}, react.createElement(Visibility, props_13)));
                })))) : empty(), delay(() => {
                    let elements_6, elements_5, elements_4, props_15, document$, category_1, matchValue_4, categoryId_1, $key6D741C94, $keyZ21FF2D0D;
                    return singleton(MuiHelpers_createElement(TableCell, [["variant", "body"], (elements_6 = [MuiHelpers_createElement(IconButton, [["color", "primary"], ["disabled", document$_1.ContentId == null], (elements_5 = [MuiHelpers_createElement(Link, [["href", downloadUrl], (elements_4 = [(props_15 = {}, react.createElement(Download, props_15))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]), (document$ = document$_1, (category_1 = ((matchValue_4 = model.ViewMode, (matchValue_4.tag === 0) ? matchValue_4.fields[1] : undefined)), (category_1 != null) ? ((categoryId_1 = (category_1 | 0), ($key6D741C94 = document$.Guid, createElement(Upload_EditButton_13687765, {
                        key: $key6D741C94,
                        $key: $key6D741C94,
                        customerId: document$.CustomerId,
                        onClose: (doc) => {
                            console.debug("Edit doc: %o", doc);
                            dispatch(new Message(17, [machineId, category_1, doc]));
                        },
                        document: document$,
                        treeId: categoryId_1,
                    })))) : defaultOf())), ($keyZ21FF2D0D = (`document-${document$_1.Guid}-delete-form`), createElement(Button, {
                        key: $keyZ21FF2D0D,
                        $key: $keyZ21FF2D0D,
                        document: document$_1,
                    }))], ["children", reactApi.Children.toArray(Array.from(elements_6))])]));
                }))))))))))));
            })), ["children", reactApi.Children.toArray(Array.from(elements_7))]));
        })))))))))));
    }, filteredDocs), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_6))]]))], ["children", reactApi.Children.toArray(Array.from(elements_9))])]);
    const xs_5 = [createElement(SnackError, {
        errMsg: unwrap(patternInput_2[0]),
        dismiss: () => {
            setErrMsg(undefined);
        },
    }), createElement(Documents_VisibilityPopup_Z6D335E41, {
        onUpdate: (doc_1) => {
            dispatch(new Message(17, [machineId, doc_1.CategoryTreeId, new Document$(doc_1.Guid, doc_1.Number, doc_1.CustomerId, doc_1.Title, doc_1.CategoryTreeId, doc_1.TypeId, doc_1.Machine, doc_1.SourceId, doc_1.Date, doc_1.Uploader, !doc_1.IsHidden, doc_1.IsDeleted, doc_1.Version, doc_1.Uploaded, doc_1.ManuallyMoved, doc_1.ContentId, doc_1.Filename, doc_1.ContentSizeBytes, doc_1.Versions)]));
        },
        onClose: () => {
            dispatch(new Message(3, [undefined]));
        },
        document: unwrap(model.HiddenDoc),
    }), createElement(Documents_ContainerWithFilter_Z2776732D, {
        selectedDocs: selectedDocs,
        children: [createElement("div", createObj(ofArray([["className", join(" ", ["documents-container"])], ["style", {
            display: "flex",
            alignItems: "flex-start",
            width: 100 + "%",
        }], (elems_15 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            width: 100 + "%",
            gap: 15 + "px",
            backgroundColor: "var(--medium-grey)",
            borderRadius: 15 + "px",
        }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 40 + "ch",
            padding: 20 + "px",
            minWidth: 40 + "ch",
            maxWidth: 60 + "ch",
        }], (elems_11 = toList(delay(() => (patternInput[0] ? singleton(docsLoadingIndicators()) : append(singleton(map_1((tupledArg) => {
            const category_2 = tupledArg[0];
            const $keyZ3836D2C5 = `tree-${category_2.Id}`;
            return createElement(DrawTree, {
                key: $keyZ3836D2C5,
                $key: $keyZ3836D2C5,
                layer: 0,
                customerId: customerId,
                machineId: machineId,
                children: tupledArg[1],
                category: category_2,
            });
        }, patternInput_5[0])), delay(() => {
            let elems_10;
            return singleton(createElement("div", createObj(singleton_1((elems_10 = [createElement(TreeNode, {
                key: "tree-customer-documents",
                $key: "tree-customer-documents",
                customerId: customerId,
                machineId: machineId,
            })], ["children", reactApi.Children.toArray(Array.from(elems_10))])))));
        }))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), MuiHelpers_createElement(TableContainer, [["className", join(" ", ["large-max-width"])], ["sx", {
            padding: 30 + "px",
            backgroundColor: "var(--light-grey)",
        }], ["children", reactApi.Children.toArray([documentTable])]])], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            width: 100 + "%",
        }], ["className", join(" ", ["documents-container-item"])], (elems_14 = [createElement(TopLevel_Table_763CA090, {
            groupId: groupId,
            customerId: customerId,
            machineId: machineId,
            documents: patternInput_5[1],
        })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))],
        machineId: machineId,
    })];
    return react.createElement(react.Fragment, {}, ...xs_5);
}

